import { msg } from '../messages'
import * as Util from '../util'

export function empty(value: any) {
  if (!Util.isEmpty(value)) {
    return msg('empty', value)
  }
}
